module.exports = __webpack_public_path__ + "media/Glenda.ba5a1c6c.mp4";